// externals
import type { Reducer } from 'redux';

// libraries
import {
    reducer as tradeInReducer,
    getAllRoutes,
    TRADE_IN,
    TradeInCardDetails,
    TradeInSummary,
    ITradeInComponentState
} from '@makemydeal/dr-activities-tradein';
import * as offerSelectors from '@makemydeal/dr-dash-store/selectors/offerSelectors';
import * as tradeShopperActivity from '@makemydeal/dr-dash-store/shopperActivities/trade';

// interfaces/types
import type { IFlowConfig } from '../../flowMasterInterfaces';

// utils
import { tradeInMiddleware } from './middleware';

// components
import { TradeInContainer } from './components/TradeInContainer';
import { getTradeInSelectors as getConfiguredTradeInSelectors } from './config';

export const tradeInRoutes = getAllRoutes();

/**
 * Whether `configureTradeIn()` has run and created this app's trade selectors. It runs on
 * BOOTSTRAP_SUCCESS, and only when the init payload carries `staticImages` and `services.gateway`,
 * so bootstrap succeeding is necessary but not sufficient. `TradeInContainer.mapStateToProps`
 * destructures those selectors unguarded, so mounting trade before this is true throws.
 */
export const isTradeConfigured = (): boolean => Boolean(getConfiguredTradeInSelectors());

export type TradeReducer = Reducer<ITradeInComponentState>;

const { getTradeInSelectors } = tradeShopperActivity;

export const tradeConfiguration: IFlowConfig<ITradeInComponentState> = {
    name: 'tradeIn',
    navCard: {
        label: 'Value My Trade-In',
        icon: 'tradeIn2',
        iconClass: 'trade-in',
        cardId: 'dr-sp-trade-in-card',
        title: 'Value Your Vehicle',
        nextStepsDescription: 'Use Kelley Blue Book to see what your current car is worth towards your new vehicle.',
        nextStepsTitle: `Don't have a vehicle to trade-in?`,
        mobileDescription: 'Get a trusted Kelley Blue Book® estimate.',
        dashboardIcon: 'carDollarSign',
        timeSaved: 26,
        detailComponent: TradeInCardDetails,
        summaryComponent: TradeInSummary
    },
    showCardSelector: (state) => getTradeInSelectors().showTradeCard(state),
    isCompleteSelector: (state) => getTradeInSelectors().isTradeInAppCardCompleted(state),
    isUnavailableSelector: (state) => getTradeInSelectors().isTradeInUnavailable(state),
    routingComponent: TradeInContainer,
    defaultRoute: TRADE_IN,

    routes: [...Object.keys(tradeInRoutes).map((routeName) => (tradeInRoutes as any)[routeName])],
    middleware: tradeInMiddleware,
    reducer: tradeInReducer,
    isLocked: () => false,
    dependsOnLeadFormCompletion: () => false,
    status: (state) => getTradeInSelectors().tradeInStatus(state),
    isDisabled: () => false,
    showInNextSteps: (state) => !offerSelectors.isOfferFromExternalSource(state),
    showOnDealerOffer: () => true
};
